import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { Metadata, PagedRolesResponse, Role, SettingsApi } from "src/app/hickory-api";
import { AuthZAccessControl } from "../../../authentication/access-control";
import { AuthService } from "../../../authentication/auth.service";
import { AddRoleAuthorizationComponent } from "../../add-role-authorization/add-role-authorization.component";
import { AuthZCollection } from "../shared-authz-models";

export class RoleAuthZCollection extends AuthZCollection<SettingsApi, Role, PagedRolesResponse> {
  override get can() { return AuthZAccessControl.canAccessAuthZType(this.auth, 'role'); }

  public override get addButton() {
    return {
      show: this.can,
      icon: 'add_moderator',
      localizationKey: 'Admins.Management.Authorization.AddRoleButton'
    };
  }

  constructor(
    auth: AuthService,
    service: SettingsApi,
    metadata: Metadata,
    dialog: MatDialog,
    actions: string[]
  ) {
    super(
      auth, actions, metadata, 'Roles', 'shield',
      service, dialog, AddRoleAuthorizationComponent
    )
  }

  protected override getItemsFromSource(): Observable<PagedRolesResponse> {
    return this.service.getRolesV4(this.tenantId, 1, 250, null, true);
  }
}
